import React from "react";
import { LanguageLocaleEnum } from "../../../client/api";
import { translate } from "../../../config/translator";
import RoundedRectangle from "../RoundedRectangle";
import PlayerRating from "../PlayerRating";
import StatItem from "./StatItem";
import type { PlayerStats } from "../../../config/types";

type PlayerStatsPanelProps = {
  stats: PlayerStats | null;
  rating: number | null | undefined;
  shouldShowRating: boolean;
  l: LanguageLocaleEnum;
};

const PlayerStatsPanel: React.FC<PlayerStatsPanelProps> = ({
  stats,
  rating,
  shouldShowRating,
  l
}) => {
  if (!stats && !shouldShowRating) return null;

  return (
    <RoundedRectangle
      className="rounded-xl mb-4 bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark"
      hasBorder
      hasTitle
      titleType="upLeft"
      titleKey="statistics"
    >
      <div className="px-6 xl:px-8 pt-4 pb-3">
        <div className="grid grid-cols-4 gap-4 mb-2">
          <StatItem value={stats?.goals ?? "-"} label={translate("goals", l)} />
          <StatItem value={stats?.assists ?? "-"} label={translate("assists", l)} />
          <StatItem value={stats?.matches ?? "-"} label={translate("matches", l)} />
          <StatItem value={stats?.lineup ?? "-"} label={translate("starting11", l)} />
        </div>

        <div className="grid grid-cols-4 gap-4">
          <StatItem value={stats?.minutes ?? "-"} label={translate("minutes", l)} />
          <StatItem value={stats?.motm ?? "-"} label="MOTM" />
          <StatItem value={stats?.totw ?? "-"} label="TOTW" />
          {shouldShowRating && rating ? (
            <div className="flex flex-col items-center">
              <PlayerRating rating={rating} size="md" showShadow />
              <span className="text-xs text-font-600 dark:text-font-600-dark mt-1">
                Rating
              </span>
            </div>
          ) : (
            <StatItem value="-" label="Rating" />
          )}
        </div>
      </div>
    </RoundedRectangle>
  );
};

export default PlayerStatsPanel;

